<template>
  <scout-form
    :is-modified="!!value"
    label="性別"
    half
  >
    <label
      v-for="(gender ,i) in genderOptions"
      :key="i"
      class="pega-badge-radio pega-mr-5"
    >
      <input
        :checked="value === gender.id"
        :value="gender.id"
        :data-test="`gender-${gender.id}`"
        type="radio"
        @change="$emit('input', $event.target._value)"
      >
      <span
        :data-test="`gender-name-${gender.id}`"
        class="pega-badge-radio-text pega-badge-radio-check-mark"
      >{{ gender.name }}</span>
    </label>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  computed: {
    genderOptions () {
      return [{ id: null, name: '指定なし' }, ...this.genderMaster]
    },
    ...mapGetters([
      'genderMaster'
    ])
  }
}
</script>
